import { FaTrash } from "react-icons/fa";
import { Table } from "containers/Table";
import { IColum } from "containers/Table/interfaces";
import { alertaWarnig } from "components/Alerta";
import { converterDataHoraBr } from "_utils/Data";
import { IEstampagemPlacaItem, ILoteEstampagem } from "../../../interfaces/ILoteEstampagem";

interface ItensTableProps {
  itens: IEstampagemPlacaItem[];
  lote: ILoteEstampagem;
  onAbrirProcesso: (idProcesso: string) => void;
  onRemoverItem: (id: number) => Promise<void>;
  onRecarregar: () => Promise<void>;
}

export function ItensTable({ itens, lote, onAbrirProcesso, onRemoverItem, onRecarregar }: ItensTableProps) {
  const columns: IColum<IEstampagemPlacaItem>[] = [
    {
      name: <span>Placa</span>,
      selector: ({ placa }) => placa,
      width: "110px",
    },
    {
      name: <span>ID Processo</span>,
      selector: ({ idProcesso }) => idProcesso ? (
        <button
          style={{ background: "none", border: "none", cursor: "pointer", color: "#0d6efd", padding: 0, textDecoration: "underline", fontSize: "inherit" }}
          onClick={() => onAbrirProcesso(idProcesso)}
        >
          {idProcesso}
        </button>
      ) : "-",
      width: "140px",
    },
    ...(lote.comTag ? [{
      name: <span>Tag</span>,
      selector: ({ tag }: IEstampagemPlacaItem) => tag ? (
        <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <span style={{ fontFamily: "monospace", fontSize: "0.8rem" }}>{tag}</span>
          <span style={{ fontSize: "0.7rem", color: "#198754", fontWeight: 600 }}>
            {lote.tagJaRegistrada ? "✓ Já registrada" : "✓ Vinculada"}
          </span>
        </div>
      ) : (
        <span style={{ fontSize: "0.75rem", color: "#dc3545", fontWeight: 600 }}>✗ Sem tag</span>
      ),
    } as IColum<IEstampagemPlacaItem>] : []),
    {
      name: <span>Adicionado em</span>,
      selector: ({ criadoEm }) => criadoEm ? converterDataHoraBr(criadoEm) : "-",
      width: "160px",
    },
    {
      name: <span>Ações</span>,
      selector: (item) => lote.status === "ABERTO" ? (
        <button
          title="Remover placa"
          style={{ background: "none", border: "none", cursor: "pointer", color: "#dc3545", padding: "4px 6px" }}
          onClick={async () => {
            const { isConfirmed } = await alertaWarnig(
              "Remover placa",
              `Deseja remover a placa ${item.placa}?`,
              { showCancelButton: true, confirmButtonText: "Remover" }
            );
            if (isConfirmed) {
              await onRemoverItem(item.id);
              await onRecarregar();
            }
          }}
        >
          <FaTrash style={{ width: 14, height: 14, display: "block" }} />
        </button>
      ) : null,
      width: "70px",
    },
  ];

  const itensPorPlaca = [...itens].sort((a, b) => a.placa.localeCompare(b.placa));

  return (
    <Table
      keyField="id"
      columns={columns}
      data={itensPorPlaca}
      loading={false}
      pagination={false}
      noSubHeader
    />
  );
}
